<!-- Backdrop -->
<div *ngIf="isOpen"
  class="fixed inset-0 bg-black bg-opacity-40 z-[999] transition-opacity duration-300"
  (click)="close()">
</div>

<!-- Drawer Panel -->
<div
  class="fixed top-0 right-0 h-full w-full max-w-[480px] bg-white z-[1000] shadow-2xl flex flex-col transition-transform duration-300"
  [class.translate-x-0]="isOpen"
  [class.translate-x-full]="!isOpen">

  <!-- Header -->
  <div class="drawer-header flex items-start justify-between px-6 py-5 border-b border-gray-100">
    <div>
      <h2 class="text-lg font-semibold text-gray-900 leading-tight">{{ isEditMode ? 'Edit Shift' : 'Create Shift' }}</h2>
      <p class="text-sm text-gray-500 mt-0.5">{{ isEditMode ? 'Modify the existing work shift.' : 'Define a new work shift for your organization.' }}</p>
    </div>
    <button type="button" (click)="close()"
      class="close-btn ml-4 text-gray-400 hover:text-gray-600 transition-colors duration-150 focus:outline-none">
      <mat-icon style="font-size:16px;width:16px;height:16px;">close</mat-icon>
    </button>
  </div>

  <!-- Scrollable Body -->
  <div class="shift-form overflow-y-auto px-6 py-5">
    <app-shift-form
      [editingShift]="editingShift"
      [isEditMode]="isEditMode"
      [employees]="employees"
      (formSubmit)="onFormSubmit($event)"
      (formCancel)="close()">
    </app-shift-form>
  </div>

  <!-- Sticky Footer -->
  <div class="px-6 py-4 border-t border-gray-100 bg-white flex items-center justify-end gap-3">
    <button mat-raised-button type="button" (click)="close()"
      class="cancel-btn">
      Cancel
    </button>
    <button mat-raised-button type="button"
      onclick="document.querySelector('app-shift-form form').dispatchEvent(new Event('submit', {bubbles:true, cancelable:true}))"
      class="save-changes-btn flex items-center gap-2">
      <mat-icon>{{ isEditMode ? 'edit' : 'add' }}</mat-icon>
      {{ isEditMode ? 'Update Shift' : 'Create Shift' }}
    </button>
  </div>
</div>
